import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { WorkOrderService } from '../../core/api/work-order.service';
import { WorkOrderRow } from '../../shared/models/work-order';
import { AppNavComponent } from '../../shared/app-nav.component';
import { BackButtonComponent } from '../../shared/back-button.component';
import { TranslatePipe } from '../../shared/translate.pipe';
import { StatusLabelPipe } from '../../shared/status-label.pipe';

@Component({
  standalone: true,
  imports: [RouterLink, AppNavComponent, BackButtonComponent, TranslatePipe, StatusLabelPipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <app-back></app-back>
        <h1>{{ 'wo.rowTitle' | t }}</h1>
      </header>
      @if (item(); as r) {
        <section class="detail-card">
          <div class="detail-heading">
            <div>
              <p class="eyebrow">#{{ r.Id }}</p>
              <h2>{{ r.ServiceRequestTypeName || ('wo.rowTitle' | t) }}</h2>
            </div>
            <span class="status-pill">{{ (r.StatusName | statusLabel) || '—' }}</span>
          </div>
          <dl>
            <dt>{{ 'wo.sequence' | t }}</dt><dd>{{ r.SequenceNumber ?? '—' }}</dd>
            <dt>{{ 'wo.cargoType' | t }}</dt><dd>{{ r.CargoTypeName || '—' }}</dd>
            <dt>{{ 'wo.packagingType' | t }}</dt><dd>{{ r.PackagingTypeName || '—' }}</dd>
            <dt>{{ 'wo.packagingQuantity' | t }}</dt><dd>{{ r.PackagingQuantity ?? '—' }}</dd>
            <dt>{{ 'wo.quantity' | t }}</dt><dd>{{ r.Quantity ?? '—' }}</dd>
            <dt>{{ 'wo.numberOfTransportUnits' | t }}</dt><dd>{{ r.NumberOfTransportUnits ?? '—' }}</dd>
            <dt>{{ 'wo.manipulation' | t }}</dt><dd>{{ r.ManipulationName || '—' }}</dd>
            <dt>{{ 'wo.workOrganizationUnit' | t }}</dt><dd>{{ r.WorkOrganizationUnitName || '—' }}</dd>
            <dt>{{ 'common.warehouse' | t }}</dt><dd>{{ r.WarehouseName || '—' }}</dd>
            <dt>{{ 'wo.berth' | t }}</dt><dd>{{ r.BerthName || '—' }}</dd>
            <dt>{{ 'wo.transportType' | t }}</dt><dd>{{ r.TransportTypeName || '—' }}</dd>
            <dt>{{ 'wo.requestedGroups' | t }}</dt><dd>{{ r.RequestedGroups ?? '—' }}</dd>
            <dt>{{ 'wo.serviceRequest' | t }}</dt><dd>{{ r.ServiceRequestName || '—' }}</dd>
            <dt>{{ 'common.remarks' | t }}</dt><dd>{{ r.Remarks || '—' }}</dd>
          </dl>
        </section>
        @if (error()) { <p class="error notice">{{ error() | t }}</p> }
      } @else if (error()) { <p class="error notice">{{ error() | t }}</p> } @else { <div class="skeleton-detail">
        <div class="skeleton-heading"></div>
        <div class="skeleton-line w-70"></div>
        <div class="skeleton-line w-55"></div>
        <div class="skeleton-line w-85"></div>
        <div class="skeleton-line w-40"></div>
      </div> }
    </main>
  `
})
export class WorkOrderRowDetailPage implements OnInit {
  readonly item = signal<WorkOrderRow | null>(null);
  readonly error = signal('');
  workOrderId = '';

  constructor(private readonly route: ActivatedRoute, private readonly api: WorkOrderService) {}

  ngOnInit(): void {
    this.workOrderId = this.route.snapshot.paramMap.get('id') ?? '';
    const rowId = this.route.snapshot.paramMap.get('rowId') ?? '';
    if (!rowId) { this.error.set('wo.missingRowId'); return; }
    this.api.getRow(rowId).subscribe({
      next: item => this.item.set(item),
      error: err => this.error.set(err?.error?.Message ?? err?.error?.message ?? 'wo.rowLoadError')
    });
  }
}
